import React from 'react';
import {
  Modal,
  FormLabel,
  Textarea,
  Flex,
  Button,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Heading,
  Spacer,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react';
import {CustomInput} from '../../../General/FormInputs';
import BoxCard from '../../../General/BoxCard';
import OppIndividual from './OppIndividual';
import OppManager from './OppManager';
import OppPlanType from './OppPlanType';
import EmployeeInfo from './EmployeeInfo';
import {useClientOpp} from '../../../../views/Maintenance/OppPlanMaintenance';
import {useForm} from 'react-hook-form';
import {Employee} from '../../../../service/Urls';
import {post} from '../../../../service/ApiService';
import {emptyEmployee} from './OppEmployee';
import {useQueryClient} from 'react-query';

export default function AddOppEmployee({isOpen, onClose, setToast}) {
  const {client} = useClientOpp();

  const queryClient = useQueryClient();

  const {
    register,
    handleSubmit,
    control,
    formState: {errors},
  } = useForm({defaultValues: {...emptyEmployee}});

  const onSubmit = async data => {
    if (!client.client) {
      setToast({response: {error: 'yep'}, errorMessage: 'First select a client to assign this employee to'});
      return;
    }

    data.emDept = parseInt(data.emDept);
    if (!data?.emTdate || data.emTdate === '') {
      data.emTdate = null;
    }

    data.clientOId = client.opp.id;

    const retVal = await post(Employee.ADD, data);

    queryClient.invalidateQueries('employee');
    onClose();

    setToast({response: retVal, successMessage: 'Successfully added employee', errorMessage: "Error: Employee couldn't be added"});
  };

  return (
    <Modal blockScrollOnMount={false} size={'full'} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          <Heading>Add Employee</Heading>
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Flex w={{base: '100%', xl: '85%'}}>
              <EmployeeInfo register={register} errors={errors} control={control} />
            </Flex>

            <Flex w={{base: '100%', xl: '85%'}}>
              <OppIndividual register={register} errors={errors} />
              <OppManager register={register} errors={errors} />
              <OppPlanType control={control} />
            </Flex>

            <BoxCard w={{base: '100%', xl: '85%'}}>
              <Flex justify={'left'}>
                <CustomInput
                  register={register}
                  id="emAlias1"
                  name="Alias 1"
                  errors={errors} // isReadOnly={employee ? false : true}
                />

                <CustomInput
                  register={register}
                  id="emAlias2"
                  name="Alias 2"
                  errors={errors}
                  // isReadOnly={employee ? false : true}
                />

                <CustomInput
                  register={register}
                  id="emAlias3"
                  name="Alias 3"
                  errors={errors}
                  // isReadOnly={employee ? false : true}
                />
              </Flex>
              <FormLabel htmlFor="clComment" mb="-0.5" ml="1" fontSize="sm">
                Comments
              </FormLabel>
              <Textarea
                placeholder="Comment"
                id="emComment"
                {...register('emComment')}
                // isReadOnly={employee ? false : true}
              />

              <Flex justify="space-between" mt={4}>
                <Button colorScheme="secondary" w="100px" type="submit">
                  Save
                </Button>
              </Flex>
            </BoxCard>
          </form>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
